import React, { useState, useEffect } from 'react';
import './Technology.scss';

const Technology = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);

      observer.observe(entry.target);
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });

  return (
    <div className="technology" id="third">
      <div className="mqtech1">
        <div id="Technology" className="technologyFirst" ref={setTarget}>
          <img
            className="technologyContentsLeftImage"
            src="/images/Heatsink_whiteback.png"
            alt="heatsink"
          />
          <div className="technologyContentsRight">
            <div className="technologyContentsRightSlogan">
              CFD*로 설계된 고성능 히트싱크
              <div className="footer">(*Computational fluid dynamics)</div>
            </div>
            <div className="technologyContentsRightInfo">
              <p>무동력팬의 성능은 냉각 효과가 좌우합니다.</p>
              <p>TUF는 유체공학 연구자들이 사용하는</p>
              <p>CFD 기술을 활용하여</p>
              <p>겨울 캠핑 환경에 최적화된 무동력팬 핵심 부품을</p>
              <p>직접 개발하였습니다.</p>
            </div>
          </div>
        </div>
        <div className="technologyFirst">
          <img
            className="technologyContentsLeftImagetwo"
            src="/images/Streamline_back.png"
            alt="CFDlines"
          />
          <div className="technologyContentsLeft">
            <div className="technologyContentsLeftInfo">
              <p>겨울 캠핑과 동일한 환경,</p>
              <p>사용하는 난로의 사이즈와 온도 조건을 똑같이 재현하여,</p>
              <p>설계 도안의 작동 온도와 유속을 시뮬레이션 하였습니다.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mqtech2">
        <div className="technologySecond">
          {/* {...animatedItem1}> */}
          <div className="technologyContentsLeft">
            <div className="technologyContentsRightSlogan">
              오리지널 TEF를 뛰어넘는 방열성능
            </div>
            <img
              className="technologyContentsRightImageone"
              src="/images/v4_32.png"
              alt="heatsink"
            />
            <div className="technologyContentsRightInfo">
              <p>30개 이상의 방열핀 형태를 시뮬레이션하여 </p>
              <p>무동력팬을 위한 최적의 히트싱크를 설계하고</p>
              <p>TEF 오리지널 제품과의 열전달 성능을 비교하였습니다.</p>
              <p>기존 TEF 와의 시뮬레이션 비교 결과,</p>
              <p>히트싱크 방열부 최고 온도가 TEF 대비 40도 가량 낮아,</p>
              <p>더 높은 출력과 안정적인 구동을 확보하였습니다.</p>
            </div>
            <div className="midtextbold">미군용 TEF 대비</div>
            <div className="deg">40°C 낮은 온도</div>
            <div className="technologyContentsRightInfo">
              (히트싱크 최고점 온도 기준)
            </div>
            <div className="technologyContentsRightDetailInfo">
              [상세 경계 조건 및 해석모델]
              <ul className="technologyContentsRightDetailInfoList">
                <li>Inlet air temp : 10 °C</li>
                <li>Stove top temp : 330°C</li>
                <li>Mesh numbers : 12 million (tetrahedral/hexa)</li>
                <li>K-epsilon analysis model applied</li>
                <li>Total thermal energy model applied</li>
                <li>Heat transfer option : Conservative heat flux</li>
              </ul>
            </div>
          </div>
          <div className="technologyContentsLeft">
            <img
              className="technologyContentsRightImagetwo"
              src="/images/v4_32.png"
              alt="heatsink"
            />
          </div>
        </div>
      </div>

      {/* <div className="technology2">
        <div className="technologyThird">
          {...animatedItem2}>
          <div className="technologyContentsLeft">
            <div className="technologyContentsRightSlogan">
              놀라운 성능의 고성능 열전 소자
            </div>
            <div className="technologyContentsRightInfo">
              <p>성능 요구 조건에 부합하는 열전 소자를 찾기 위해,</p>
              <p>오리지널 TEF의 소자 제조사를 비롯한 </p>
              <p>세계 각국 20여개 제조사의</p>
              <p>수많은 샘플 테스트를 진행하고</p>
              <p>TUF에 가장 적합한 소자를 찾아내고야 말았습니다.</p>
            </div>
            <div className="midtextbold">무부하 전압</div>
            <div className="deg">14.4 V</div>
            <div className="midtextbold">최대 출력</div>
            <div className="deg">22 W</div>
          </div>
        </div>
      </div> */}
      {/* <div className="technology2">
        <div className="technologyFourth">
          {...animatedItem3}>
          <div className="technologyContentsLeft">
            <div className="technologyContentsRightSlogan">
              1천도 이상의 고온을 견디는 KCC 초고온 단열재
              대류형 등유난로에 최적화된 설계
            </div>
            <div className="technologyContentsRightInfo">
              <p>오리지널 TEF는 대류형 등유난로가 아닌</p>
              <p>복사열을 방출하는 난로를 타겟으로 만들어졌습니다.</p>
              <p>강한 대류열을 방출하는 등유난로에는</p>
              <p>그에 걸맞는 새로운 설계가 필요합니다.</p>
              <br />
              <p>TUF는 국내 캠퍼들이 가장 많이 사용하는</p>
              <p>등유난로의 특성에 최적화된 설계로</p>
              <p>난로의 연료가 소진될 때 까지</p>
              <p>균일한 성능을 제공합니다.</p>
              <br />

              <div className="midtextbold">권장 사용 시간</div>
              <div className="deg">14시간</div>
              <div className="technologyContentsRightInfo">
                (연료 소진 시 까지 사용 가능)
              </div>
              <p>무동력 팬의 성능과 안전을 위해서</p>
              <p>KCC 의 무석면 무기 단열재를 사용합니다.</p>
              <br />
              <p>발전소, 제철소 등 초고온 환경에서 사용하는</p>
              <p>검증된 단열 성능과 높은 생분해성으로,</p>
              <p>유럽 동물시험기준 (Direncive 97/69/EC)과</p>
              <p>독일 동물시험기준 (TRGS905) 을 통과한</p>
              <p>인체에 무해한 단열재입니다.</p>
            </div>
            <div className="midtextbold">내열 온도</div>
            <div className="deg">1,260°C</div>
          </div>
        </div>
      </div> */}
      <div className="mqtech5">
        <div className="technologyFifth">
          <div className="technologyContentsMidSlogan">
            대류 열전달 효과를 극대화하는 디테일한 설계
          </div>
          <img
            className="technologyImage"
            src="./images/Designpage3.png"
            alt="heatsink"
          />
          <img
            className="technologyImage2"
            src="./images/Designpagewide.png"
            alt="heatsink"
          />
          {/* <div className="technoligyFifthset">
            <div className="technologyContentsLeft">
              <div className="technologyContentsLeftSolgan">
                벨마우스형 토출구
              </div>
              <ul className="technologyContentsLeftInfo">
                <li>토출구 외곽이 바깥으로 돌출된 벨마우스 가공</li>
                <li>따뜻한 공기가 가장 잘 분산되도록 구현한 최적 방사각</li>
              </ul>
              <div className="technologyContentsLeftSolgan">
                핫플레이트 가이드
              </div>
              <ul className="technologyContentsLeftInfo">
                <li>
                  난로의 열기가 히트싱크의 성능을
                  <br />
                  저하시키지 않도록 설계된
                  <br />
                  핫플레이트 가이드
                </li>
              </ul>
            </div>

            <div className="technologyContentsLeft">
              <img
                className="technologyContentsRightImage"
                src="/images/split render.png"
                alt="heatsink"
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Technology;
